// Route "/certification-membre/:id" (notification « Demande de certification », ADR-020) :
// deux segments exactement, identifiant cuid de la demande.
const REQUEST_ID_PATTERN = /^[a-z0-9]{20,40}$/;

export function matchMemberCertificationPath(pathname) {
  const segments = String(pathname || "").split("/").filter((segment) => segment.length > 0);
  if (segments.length !== 2 || segments[0] !== "certification-membre") return null;
  return REQUEST_ID_PATTERN.test(segments[1]) ? segments[1] : null;
}
